import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Parametros", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "bg-surface px-2 py-2 h-100",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Parametros do Sistema ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            ref: "form",
            "validate-on": "blur",
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "hidden",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.usuario.id) = $event))
              }, null, 512), [
                [_vModelText, _ctx.params.usuario.id]
              ]),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "2",
                        md: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            type: "number",
                            autofocus: "",
                            modelValue: _ctx.params.usuario.idSistema,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.usuario.idSistema) = $event)),
                            label: "Cód. Sistema",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "7",
                        md: "7"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            density: "compact",
                            modelValue: _ctx.params.usuario.nome,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.usuario.nome) = $event)),
                            label: "Razão",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "2",
                        sm: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.params.usuario.ativo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.usuario.ativo) = $event)),
                            label: "Ativo?"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        label: "Filtro"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params.parametros, (par) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          key: par.nome,
                          cols: "12",
                          sm: "4",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              "v-model": par.valor,
                              label: par.titulo,
                              color: "red",
                              value: "red",
                              "hide-details": ""
                            }, null, 8, ["v-model", "label"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        justify: "space-between",
                        class: "text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "5",
                            sm: "5",
                            xs: "5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                size: "large",
                                type: "submit",
                                variant: "outlined",
                                class: "mt-4 w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Confirmar ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "5",
                            sm: "5",
                            xs: "5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "warning",
                                size: "large",
                                type: "button",
                                variant: "outlined",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasHistory() ? _ctx.$router.go(-1) : _ctx.$router.push('/'))),
                                class: "mt-4 w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Cancelar ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}